import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import Table from "../../../../common/components/table";
import { selectTenantWebsitesListItems } from "../../../../redux/tenant-websites/selector";
import { tenantWebsites } from "../../../../redux/tenant-websites/action";
import { tenantWebsiteCards } from "../../../../redux/tenant-website-cards/action";
import PageLoader from "../../../../components/PageLoader";

const TenantWebsites = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const parmas: any = useParams()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
	const { header, footer, currency } = result
    const websitesItems = useSelector(selectTenantWebsitesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const [
        updatedRowData,
        setUpdatedRowData
      ] = useState<any>([]);
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'WebSiteName', headerName: 'WebSiteName',searchField: 'WebsiteName', filter: true,
            filterType: 'text' },
          { headerName: 'Reset', cellRenderer: 'resetIconRenderer' },
          { field: 'HostingUrl', headerName: 'HostingUrl', sortable: false, filter: false ,input: true,type:'text' },
          { field: 'MappedDomain', headerName: 'MappedDomain', sortable: false, filter: false,input: true,type:'text'},
          { field: 'DisplayOrder', headerName: 'DisplayOrder', sortable: false, filter: false,input: true,type:'text' },
          { field: 'Remarks', headerName: 'Remarks',input: true,type:'text'},
          { headerName: 'Update', isUpdateTenantWebsite: true },
          { headerName: 'Enable', isEnableTenantWebsite: true }
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
       navigate(`${data?.PlatformWebSiteId}`)
      }
     
  const handleInputChange = (event: any, field: any, row: any) => {
    const { value } = event.target;
    setUpdatedRowData((prevUser: any) => ({
      ...prevUser,
      [field]: value, 
    }));
  };
     
  
      const handlereset = async (data: any) => {
        const { PlatformWebSiteId, StoreId, DepartmentId } = data;
        const requestData = {
          PlatformWebSiteId,
          StoreId,
          DepartmentId,
          TenantId: Number(parmas?.id)
        }; 
        dispatch(tenantWebsites.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/sync-website-with-platform-website-template`,entity:'tenantWebsites',jsonData:{
          
        Records: [
          { 
            "Context": {},
            "Message": {
             ...requestData
            }
        } 
        ]
    }})).then(() => {
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
          }
        ],
    
        }}))
    });
      
    }
  
      const handleUpdateTenantWebsite = async (data: any) => {
       
      dispatch(tenantWebsiteCards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/add-new-cards-to-tenant-websites`,entity:'tenantWebsiteCards',jsonData:{
       
        Records: [
          { 
            "Context": {},
            "Message": {
              TenantId: parmas?.id,
              PlatformWebSiteId: data?.PlatformWebSiteId,
              StoreId: data?.StoreId,
              DepartmentId: data?.DepartmentId
            }
        } 
        ]
    }})).then(() => {
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
          }
        ],
    
        }}))
    });
    }
    const handleEnableTenantWebsite = async (data: any) => {
        dispatch(tenantWebsites.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`,entity:'tenantWebsites',jsonData:{  
        Records: [
          {
            "Context": {},
            "Message": {
              ...data
            }
        }
        ]
      
    }}))
    .then(() => {
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
          }
        ],
    
        }}))
    });
    
    }


    const handleSave = async (data: any) => {
      dispatch(tenantWebsites.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`,entity:'tenantWebsites',jsonData:{  
      Records: [
        {
          "Context": {},
          "Message": {
            Id:data?.Id,
            TenantId: parmas?.id,
            PlatformWebSiteId: data?.PlatformWebSiteId,
            StoreId: data?.StoreId,
            DepartmentId: data?.DepartmentId,
            WebSiteName: data?.WebSiteName,
            WebSiteVersionId: data?.WebSiteVersionId,
            HostingUrl: updatedRowData?.HostingUrl ||data?.HostingUrl,
            MappedDomain: updatedRowData?.MappedDomain || data?.MappedDomain,
            DisplayOrder: updatedRowData?.DisplayOrder ||data?.DisplayOrder,
            Remarks: updatedRowData?.Remarks ||data?.Remarks
          }
      }
      ]
    
  }}))
  .then(() => {
      dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
    
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
      "Filters": [
        {
          "FieldName": "TenantId",
          "FilterOperatorId": 1,
          "FieldValue": parmas?.id,
          "FieldType": "number"
        }
      ],
  
      }}))
  });
  setUpdatedRowData({})
  }
      const handleDelete=(data: any)=>{
        dispatch(tenantWebsites.delete({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/delete`,
          entity: 'tenantWebsites',
          jsonData: {
            Records: [
                  {
                    "Context":{},
                    "Message":{
                      TenantId: parmas?.id,
                      Id: data?.Id}
                      
                  }
              ]
          }
      })).then(() => {
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
          }
        ],
    
        }}))
    });
    const handleAdd=()=>{
      navigate(`${0}`)
    }
      }
      const back=()=>{
        navigate('/web-platform/platform-management/tenants')
      } 

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id,
              "FieldType": "number"
            }
          ],
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": parmas?.id,
              "FieldType": "number"
            }
          ],
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
           <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
             <title>Add Tenant Website</title>
             <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
           </svg>,
         callback: () => handleAdd(),
       },
   
           {
             svg:
             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
             <title>Reload</title>
             <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
           </svg>,
           // name: 'Reload',
           callback: () => handleReloadData(),
           },
        {
          name: 'Back to Tenant',
          callback: () => back(),
        }
      ];
      const fetchTenantWebsites=()=>{
        dispatch(tenantWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'tenantWebsites',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
          }
        ],
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchTenantWebsites()
	}, [pageData,pageSize])

	return (
    <>
    {websitesItems?.isLoading ? <PageLoader />
    : 
		<Table  enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={websitesItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize} handlereset={handlereset} handleEnableTenantWebsite={handleEnableTenantWebsite} handleInputChange={handleInputChange} handleUpdateTenantWebsite={handleUpdateTenantWebsite} paginationData={websitesItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Tenant Websites"
        IsRowUpdated={true}  handleSave={handleSave}/>
  } 
    </> 
	);
};

export default TenantWebsites;


